import BomSourceSerializer from 'eflex/serializers/bom-source';

export default class RestPullBomSourceSerializer extends BomSourceSerializer {}
